import { DOCS_FORM_NAMES } from "core/consts";
import { ControlledTextarea } from "ds/ui";
import { FormFieldConfig } from "../..";

export const DischargeLetterENTFormSections: FormFieldConfig<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT
>["sections"] = [
  {
    fields: {
      additional_findings: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt
                .futherFindingsLabel
            }
            name="additional_findings"
            placeholder=" "
          />
        ),
        position: 7,
      },
      admission_medications: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt
                .medicationUponAdmission
            }
            name="admission_medications"
            placeholder=" "
          />
        ),
        position: 5,
      },
      anamnesis: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt
                .medicalHistoryLabel
            }
            name="anamnesis"
            placeholder=" "
          />
        ),
        position: 4,
      },
      clinical_course: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt.historyLabel
            }
            name="clinical_course"
            placeholder=" "
          />
        ),
        position: 9,
      },
      diagnoses: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt.diagnosisLabel
            }
            name="diagnoses"
            placeholder=" "
          />
        ),
        position: 1,
      },
      discharge_medications: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt
                .dischargeMedicationLabel
            }
            name="discharge_medications"
            placeholder=" "
          />
        ),
        position: 10,
      },
      findings: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt.findingsLabel
            }
            name="findings"
            placeholder=" "
          />
        ),
        position: 6,
      },
      laboratory_parameters: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt
                .laboratoryParameters
            }
            name="laboratory_parameters"
            placeholder=" "
          />
        ),
        position: 8,
      },
      recommendations: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt.recommendation
            }
            name="recommendations"
            placeholder=" "
          />
        ),
        position: 11,
      },
      secondary_diagnoses: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt
                .secondaryDiagnoses
            }
            name="secondary_diagnoses"
            placeholder=" "
          />
        ),
        position: 2,
      },
      therapy: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt.therapyLabel
            }
            name="therapy"
            placeholder=" "
          />
        ),
        position: 3,
      },
    },
    position: 1,
  },
];
